import { render, staticRenderFns } from "./propostas.vue?vue&type=template&id=2881ad94"
import script from "./propostas.vue?vue&type=script&lang=js"
export * from "./propostas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports